// const hostConfig = {
//   'zkbtest.iqcedu.com':{
//     api:'http://zkbtest.iqcedu.com'
//   },
//   'www.iqcedu.com':{
//     api:'http://www.iqcedu.com'
//   },
//   'jk.iqcedu.com':{
//     // api:'http://jk.iqcedu.com'
//     api:'/api/'
//   },
//   'jktest.iqcedu.com':{
//     api:'http://jk.iqcedu.com'
//   },
//   'localhost':{
//     api:'/api/'
//   },
//   '192.168.3.58':{
//     // api:'c'
//     api:'/api/'
//   },
//   '192.168.3.160':{
//     api:'http://192.168.3.160'
//   },
//   '192.168.3.197':{
//     // api:'http://192.168.3.197'
//   },
//   '127.0.0.1':{
//     // api:'http://127.0.0.1'
//     api:'/api/'
//   },
// }
//
// //根据当前访问的主机获取对应的接口服务地址
// export const serverApi = function () {
//   var hostname = window.location.hostname;
//   //处理定制化二级域名
//   if(hostname.indexOf('.iqcedu.com') >= 0){
//     hostname = "www.iqcedu.com"
//   }
//   return hostConfig[hostname].api;
// }

export default {
  method: 'post',
  // 基础url前缀
  baseURL:'/openApi',
  // 请求头信息
  headers: {
    'Content-Type':'application/json;charset=UTF-8'
  },
  // 参数
  data: {},
  // 设置超时时间
  timeout: 10000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: 'json'
}





// WEBPACK FOOTER //
// ./src/http/config.js